import { render, staticRenderFns } from "./AgreedAmount.vue?vue&type=template&id=3c970010&"
import script from "./AgreedAmount.vue?vue&type=script&lang=js&"
export * from "./AgreedAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports